module.exports = __webpack_public_path__ + "files/b5418750bd914b2f8522a24d8860ee70.png";